import { safeClone, ViewStream } from "spyne";
import { PageTraits } from "traits/page-traits";
import { PageDocsItem } from "components/pages/page-docs-item";

export class PageCompare extends ViewStream {
  constructor(props = {}) {
    props.traits = PageTraits;
    props.data = safeClone(props.pageData);
    props.id = "l1-compare";
    props.class = "app-page";
    const len = props.appData.content.length;
    props.data.appData = props.appData.content[len - 1];
    props.template = require("./templates/page-compare.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [["CHANNEL_APP_ROUTE_PAGE_CHANGE_EVENT", "disposeViewStream"]];
  }

  broadcastEvents() {
    let broadcastArr = [];
    const containsLinks = this.props.el$("a").exists;
    broadcastArr = containsLinks
      ? broadcastArr.push(["a", "click"])
      : broadcastArr;
    return broadcastArr;
  }

  addPageDocItems() {
    const addPageItems = (data) => {
      this.appendView(new PageDocsItem({ data }), ".page-content");
    };

    this.props.appData.comparePageContent.forEach(addPageItems);
  }

  onRendered() {
    // this.prependView(new ViewStream({template : `${MySVG.default}`}))

    this.addChannel("CHANNEL_APP_ROUTE", true);
    this.page$InitPage();
    this.page$checkFor404();
    this.addPageDocItems();

    // this.appendView(new CodePlaygroundContainer({codeBlockId: "homePageTest1"}), "#page-header");
    // this.appendView(new CodePlaygroundContainer({codeBlockId: "homePageTest2"}), ".page-content");
    //this.appendView(new CodePlaygroundContainer(), ".page-content");
  }
}
